import { ObjectWithAnyValues } from "utils/types";
import { BaseModel } from "../BaseModel";
import { TenantFields, TenantProps } from "./types";

export class Tenant extends BaseModel {
	[TenantFields.ID]: string;
	[TenantFields.NAME]: string;
	[TenantFields.TYPE_ID]?: string;
	[TenantFields.TYPE]: string;
	[TenantFields.DESCRIPTION]: string;
	[TenantFields.URL]: string;
	[TenantFields.HOMOLOGATION]: string;
	[TenantFields.BACKOFFICE]: string;

	constructor(data: TenantProps) {
		super(data);

		this[TenantFields.ID] = data[TenantFields.ID];
		this[TenantFields.NAME] = data[TenantFields.NAME];
		this[TenantFields.TYPE] = data[TenantFields.TYPE];
		this[TenantFields.TYPE_ID] = data[TenantFields.TYPE_ID];
		this[TenantFields.DESCRIPTION] = data[TenantFields.DESCRIPTION];
		this[TenantFields.URL] = data[TenantFields.URL];
		this[TenantFields.HOMOLOGATION] = data[TenantFields.HOMOLOGATION];
		this[TenantFields.BACKOFFICE] = data[TenantFields.BACKOFFICE];
	}

	static override createFromResponse(response: ObjectWithAnyValues) {
		if (!response) {
			return response;
		}

		const tenant = new Tenant({
			[TenantFields.ID]: response.id,
			[TenantFields.NAME]: response.name,
			[TenantFields.TYPE]: response.type.name,
			[TenantFields.TYPE_ID]: response.type.id,
			[TenantFields.DESCRIPTION]: response.description,
			[TenantFields.URL]: response.url,
			[TenantFields.HOMOLOGATION]: response.homologUrl,
			[TenantFields.BACKOFFICE]: response.backofficeUrl
		});
		return tenant;
	}
}
